import React from "react";
import "../../styles/LoadingSpinner.css";

const LoadingSpinner = ({
  size = "18rem",
  className = "",
  text = "Loading...",
}) => {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center ${className}`}
    >
      <div className="spinner-wrapper" style={{ width: size, height: "150px" }}>
        {/*CENTER IMAGE  */}
        <img
          src="/assets/logo/loading.gif"
          alt="WiSE Logo"
          className="spinner-center-image"
        />
      </div>

      {/* Loading Text */}
      <span className="text-secondary loading-text">{text}</span>
    </div>
  );
};

export default LoadingSpinner;
